// Fetch + cache the public affiliate-URL map once per page load.
import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let cached = null;
let inflight = null;

async function fetchOnce() {
  if (cached) return cached;
  if (!inflight) {
    inflight = axios
      .get(`${API}/affiliates`)
      .then((r) => {
        cached = r.data?.links || {};
        return cached;
      })
      .catch(() => {
        cached = {};
        return cached;
      });
  }
  return inflight;
}

export function useAffiliateLinks() {
  const [links, setLinks] = useState(cached || {});
  useEffect(() => {
    let cancelled = false;
    fetchOnce().then((m) => { if (!cancelled) setLinks(m); });
    return () => { cancelled = true; };
  }, []);
  return links;
}

export function affiliateUrlFor(label, links) {
  if (!label || !links) return null;
  return links[label] || null;
}
